/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Item_Stats_Previousprice1Inputs */

const he_item_stats_previousprice1 = /** @type {(inputs: Item_Stats_Previousprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מחיר קודם`)
};

const en_item_stats_previousprice1 = /** @type {(inputs: Item_Stats_Previousprice1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Previous price`)
};

/**
* | output |
* | --- |
* | "Previous price" |
*
* @param {Item_Stats_Previousprice1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const item_stats_previousprice1 = /** @type {((inputs?: Item_Stats_Previousprice1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Item_Stats_Previousprice1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_item_stats_previousprice1(inputs)
	return en_item_stats_previousprice1(inputs)
});
export { item_stats_previousprice1 as "item_stats_previousPrice" }